import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { putRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import './AddProject.scss';
import FilterTag from '../common/FilterTag';
import customStyles from '../../dropdownStyleUtils';
import DropdownIndicator from '../common/DropdownIndicator';
import DocumentUpload from '../DocumentUpload';
var firstName = function firstName(consultant) {
  return consultant.name ? consultant.name.split(' ')[0] : consultant.email;
};
var handleCancel = function handleCancel() {
  window.location.href = '/projects';
};
var handleAfterUpload = function handleAfterUpload(redirectUrl) {
  analyticsTrack('Uploaded job description', {
    location: 'Add Project'
  });
  window.location = redirectUrl;
};
var additionalLabelStyle = {
  marginLeft: 0
};
var AddProject = /*#__PURE__*/function (_Component) {
  function AddProject(props) {
    var _this;
    _classCallCheck(this, AddProject);
    _this = _callSuper(this, AddProject, [props]);
    _this.state = {
      duplicateProject: null,
      selectedProject: null,
      selectedTemplate: null
    };
    _this.handleRadio = _this.handleRadio.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleNewProject = _this.handleNewProject.bind(_this);
    _this.handleSelectTemplate = _this.handleSelectTemplate.bind(_this);
    return _this;
  }
  _inherits(AddProject, _Component);
  return _createClass(AddProject, [{
    key: "generateTitleCopy",
    value: function generateTitleCopy() {
      var _this$props = this.props,
        hireAgain = _this$props.hireAgain,
        consultant = _this$props.consultant;
      if (hireAgain) {
        return "Which project do you want to hire ".concat(firstName(consultant), " for?");
      }
      return 'Easy ways to post a new project';
    }
  }, {
    key: "generateSubtitleCopy",
    value: function generateSubtitleCopy() {
      var _this$props2 = this.props,
        hireAgain = _this$props2.hireAgain,
        consultant = _this$props2.consultant;
      if (hireAgain) {
        return "Clora will share this information with ".concat(firstName(consultant), " and check their availability.");
      }
      return null;
    }
  }, {
    key: "isContinueDisabled",
    value: function isContinueDisabled() {
      var _this$state = this.state,
        duplicateProject = _this$state.duplicateProject,
        selectedTemplate = _this$state.selectedTemplate,
        selectedProject = _this$state.selectedProject;
      return duplicateProject === null && selectedTemplate === null || duplicateProject === true && selectedProject === null;
    }
  }, {
    key: "handleRadio",
    value: function handleRadio(bool) {
      this.setState({
        duplicateProject: bool,
        selectedTemplate: null
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(option) {
      this.setState({
        selectedProject: option
      });
    }
  }, {
    key: "handleNewProject",
    value: function handleNewProject() {
      var _this$props3 = this.props,
        hireAgain = _this$props3.hireAgain,
        onCreateNewProject = _this$props3.onCreateNewProject,
        consultant = _this$props3.consultant,
        csrfToken = _this$props3.csrfToken;
      var _this$state2 = this.state,
        duplicateProject = _this$state2.duplicateProject,
        selectedProject = _this$state2.selectedProject,
        selectedTemplate = _this$state2.selectedTemplate;
      if (duplicateProject) {
        var duplicateProjectPath = "/projects/".concat(selectedProject.value, "/duplicate");
        var params = {};
        if (hireAgain) {
          params.rehire_user_resource_id = consultant.resource_id;
        }
        analyticsTrack('Created Duplicate Project', {
          location: 'Add Project'
        });
        putRequest(duplicateProjectPath, params, csrfToken).then(function (response) {
          window.location.href = response.data.url;
        });
      } else if (hireAgain) {
        onCreateNewProject();
      } else if (selectedTemplate) {
        window.location.href = "/projects/new?project_template_id=".concat(selectedTemplate);
      } else {
        window.location.href = '/projects/new';
      }
    }
  }, {
    key: "handleSelectTemplate",
    value: function handleSelectTemplate(templateId) {
      this.setState({
        selectedTemplate: templateId,
        duplicateProject: null
      });
    }
  }, {
    key: "renderTemplateSelect",
    value: function renderTemplateSelect() {
      var projectTemplates = this.props.projectTemplates;
      var selectedTemplate = this.state.selectedTemplate;
      var projectTemplateOptions = projectTemplates.map(function (template) {
        return {
          title: template.name,
          value: template.id
        };
      });
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "heading-subtext ps-0"
      }, "Quick start with our templates to pre-fill your project details."), /*#__PURE__*/React.createElement("div", {
        className: "filter-tag-spacing"
      }, /*#__PURE__*/React.createElement(FilterTag, {
        options: projectTemplateOptions,
        handleChange: this.handleSelectTemplate,
        selected: selectedTemplate
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        projects = _this$props4.projects,
        csrfToken = _this$props4.csrfToken;
      var _this$state3 = this.state,
        duplicateProject = _this$state3.duplicateProject,
        selectedProject = _this$state3.selectedProject;
      var titleCopy = this.generateTitleCopy();
      var subtitleCopy = this.generateSubtitleCopy();
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide add-project"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3 ps-0"
      }, titleCopy), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mb-4 ps-0"
      }, subtitleCopy), /*#__PURE__*/React.createElement("div", {
        className: "subheading mb-3 ps-0"
      }, "Import your existing job description")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(DocumentUpload, {
        buttonStyle: "button",
        prompt: "Upload",
        uploadDocumentUrl: "/projects/create_from_jd",
        document: null,
        csrfToken: csrfToken,
        documentType: "job_description",
        location: "Add Project",
        handleAfterUpload: handleAfterUpload,
        skipParsing: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "row or-divider"
      }, "OR"), /*#__PURE__*/React.createElement("div", {
        className: "row subheading mb-3"
      }, "Use our templates"), /*#__PURE__*/React.createElement("div", {
        className: "row body-text-2"
      }), /*#__PURE__*/React.createElement("div", {
        className: "row template-select"
      }, this.renderTemplateSelect()), /*#__PURE__*/React.createElement("div", {
        className: "row or-divider"
      }, "OR"), /*#__PURE__*/React.createElement("div", {
        className: "row subheading mb-3"
      }, "Write your own"), /*#__PURE__*/React.createElement("div", {
        className: "row option",
        key: "duplicate-project"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "duplicate-project",
        className: "custom-radio-container",
        style: additionalLabelStyle
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "duplicate-project",
        value: "duplicate-project",
        name: "duplicate-project",
        onChange: function onChange() {
          return _this2.handleRadio(true);
        },
        checked: duplicateProject === true
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-btn"
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-text"
      }, "Duplicate my other project")), duplicateProject && /*#__PURE__*/React.createElement("div", {
        className: "select-projects mt-2 mb-2"
      }, /*#__PURE__*/React.createElement(Select, {
        components: {
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        },
        styles: customStyles,
        className: "body-text-2",
        classNamePrefix: "selected-project",
        placeholder: "Choose a project",
        options: projects.map(function (p) {
          return {
            value: p.resource_id,
            label: p.name
          };
        }),
        value: selectedProject,
        onChange: function onChange(option) {
          return _this2.handleSelect(option);
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row form-group body-text-2 my-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "option mb-3",
        key: "add-project"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "add-project",
        className: "custom-radio-container",
        style: additionalLabelStyle
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "add-project",
        value: "add-project",
        name: "add-project",
        onChange: function onChange() {
          return _this2.handleRadio(false);
        },
        checked: duplicateProject === false
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-btn"
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-text"
      }, "I'll start from scratch")))), /*#__PURE__*/React.createElement("div", {
        className: "actions actions d-flex flex-column flex-md-row justify-content-end gap-3"
      }, /*#__PURE__*/React.createElement("a", {
        className: "cancel btn",
        tabIndex: 0,
        role: "button",
        onClick: function onClick() {
          return handleCancel();
        }
      }, "Cancel"), /*#__PURE__*/React.createElement("button", {
        className: "continue".concat(this.isContinueDisabled() ? '-disabled' : '', " btn btn-primary"),
        disabled: this.isContinueDisabled(),
        onClick: this.handleNewProject
      }, "Continue")));
    }
  }]);
}(Component);
AddProject.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  projectTemplates: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hireAgain: PropTypes.bool,
  consultant: PropTypes.shape({}),
  onCreateNewProject: PropTypes.func,
  csrfToken: PropTypes.string
};
AddProject.defaultProps = {
  hireAgain: false,
  consultant: null,
  onCreateNewProject: function onCreateNewProject() {
    return null;
  },
  csrfToken: null
};
export default AddProject;